export default function HeroSection() {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden"
      style={{ height: '92vh', minHeight: '500px' }}
      aria-label="Company mission"
    >
      <div
        className="absolute bg-primary-800 overflow-hidden"
        style={{
          top: 0,
          left: '24px',
          right: '24px',
          bottom: '24px',
          borderRadius: '30px',
        }}
      >
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20mesh%20pattern%20on%20deep%20charcoal%20dark%20background%2C%20structural%20nodes%20and%20connectivity%20lines%2C%20minimal%20tech%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20dark%20atmospheric%20ambient%20lighting%2C%20clean%20mathematical%20topology%2C%20subtle%20warm%20highlights%2C%20editorial%20quality%2C%20architectural%20blueprint%20inspired%20pattern%2C%20soft%20gradient%20depth&width=1800&height=900&seq=vasko-hero-2026&orientation=landscape"
          alt="Abstract geometric mesh pattern representing engineering architecture"
          title="Engineering architecture visualization"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/50 via-primary-900/30 to-primary-900/60" />
      </div>

      <div className="relative z-10 flex flex-col items-center text-center px-4 md:px-8 w-full">
        <div className="inline-flex items-center justify-center px-5 py-2 rounded-full border border-white/20">
          <span
            className="text-[11px] font-medium uppercase tracking-[0.08em] text-white/90"
            style={{ fontFamily: 'var(--font-body)' }}
          >
            Engineering Excellence
          </span>
        </div>

        <h1
          className="mt-7 text-[40px] md:text-[68px] font-medium text-white leading-[1.1] tracking-tight max-w-[720px]"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Building Modern Digital Solutions for the iOS Platform
        </h1>

        <p
          className="mt-8 text-sm md:text-base font-light text-white/75 leading-relaxed max-w-[560px]"
          style={{ fontFamily: 'var(--font-body)', fontWeight: 300 }}
        >
          A professional engineering team focused on designing and developing scalable, maintainable, and high-performance systems with a strong emphasis on usability, stability, and long-term technical quality.
        </p>
      </div>
    </section>
  );
}